import Styled from "styled-components";

export const SwapButtonRoot = Styled.button`
  width: 32px;
  height: 32px;

  border-radius: 50%;
  border: 0;
  background: var(--primary-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;

  svg {
    display: block;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  &:focus-visible {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
  }
`;
